import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import TabItem from "../../common/Tab/TabItem";
import TabContent from "../../common/Tab/TabContent";
import ClientService from "../../../services/ClientService";
import RecipesService from "../../../services/RecipesService";
import GroceriesService from "../../../services/GroceriesService";
import PlanService from "../../../services/PlanService";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { PlusIcon } from "@heroicons/react/outline";
import { DEFAULT_INDIVIDUAL_RECOMMENDATIONS } from "../../../services/PlanDefaults";

const MySwal = withReactContent(Swal)

const Plans = () => {
    let { clientId, planId } = useParams();
    const [shouldLoad, setShouldLoad] = useState(true)
    const [plansData, setPlansData] = useState([null])
    const [selectedClients, setSelectedClients] = useState([{}])
    const [mappedTabList, setMappedTabList] = useState(null)
    const [mappedTabContent, setMappedTabContent] = useState(null)
    const [newnoOfRows, setNewNoOfRows] = useState([4]);
    const [newnoOfCommentRows, setNewNoCommentOfRows] = useState([1]);
    const [clientsData, setClientsData] = useState([])
    const [openTab, setOpenTab] = useState(1);
    const [options, setOptions] = useState([]);
    // Jelovnici po klijent-tabu: lista svih jelovnika i koji je trenutno izabran
    const [menusByTab, setMenusByTab] = useState([[]]);      // menusByTab[tabIndex] = [plan1, plan2, ...]
    const [activeMenu, setActiveMenu] = useState([0]);        // activeMenu[tabIndex] = indeks izabranog jelovnika
    const emptyPlan = {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
        times: [],
        comments: [],
        mergedRows: [],
        substituteSet: 'regular'
    }

    // Svez prazan plan sa NOVIM nizovima svaki put (da jelovnici ne dele iste
    // nizove - inace bi drugi jelovnik pokazao podatke iz prvog).
    const makeEmptyPlan = () => ({
        monday: [], tuesday: [], wednesday: [], thursday: [], friday: [], saturday: [], sunday: [],
        times: [], comments: [], mergedRows: [], mergedDays: {}, substituteSet: 'regular',
        lunchRecommendationRows: [],
        individualRecommendations: DEFAULT_INDIVIDUAL_RECOMMENDATIONS
    });

    // Duboka kopija plana - svaki jelovnik dobija potpuno nezavisne nizove,
    // da izmene u jednom (koje se rade plitkim kopijama u TabContent) ne procure
    // u drugi jelovnik istog klijenta.
    const clonePlan = (plan) => {
        if (!plan) return makeEmptyPlan();
        try {
            return JSON.parse(JSON.stringify(plan));
        } catch (e) {
            return { ...plan };
        }
    };

    // Skuplja imena recepata iz PRETHODNIH jelovnika (onih sa manjim rednim brojem
    // od trenutno aktivnog). Koristi se da se ti recepti u ponudi obeleze.
    // Vraca mapu: ime recepta -> broj jelovnika u kom se prvi put pojavljuje.
    const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const recipesFromPreviousMenus = (tabIndex) => {
        const used = {};
        const menus = menusByTab[tabIndex] || [];
        const activeIdx = activeMenu[tabIndex] || 0;
        menus.forEach((menu, mi) => {
            if (mi >= activeIdx) return; // samo prethodni jelovnici
            const menuNo = menuNumberOf(menu, mi);
            DAYS.forEach((day) => {
                const cells = (menu && menu[day]) || [];
                cells.forEach((cell) => {
                    const recipes = (cell && cell.recipes) || [];
                    recipes.forEach((r) => {
                        const name = r && (r.value || r.name || r.label);
                        if (name && used[name] === undefined) used[name] = menuNo;
                    });
                });
            });
        });
        return used;
    };

    useEffect(() => {
        if (shouldLoad) {
            setShouldLoad(false);
            getClients();
            loadDefaultData();
            getOptions();
        }

        mapTabs()
    }, [clientsData, selectedClients, plansData, newnoOfRows, newnoOfCommentRows, options, menusByTab, activeMenu])


    const getOptions = () => {
        RecipesService.getRecipes().then(response => {
            let data = response.data.map(recipe => {
                recipe.value = recipe.name
                recipe.label = recipe.name
                recipe.recipeItems.map((item) => {
                    item.label = item.ingredient.name;
                    item.value = item.ingredient.name;
                    return item;
                });
                return recipe
            })
            GroceriesService.getSGroceriesUrl().then((response) => {
                let tempData = response.data.map((item) => {
                    let groceryForSelect = { ingredient: { ...item } };
                    groceryForSelect.label = item.name;
                    groceryForSelect.ingredient.label = item.name;
                    groceryForSelect.value = item.name;
                    groceryForSelect.ingredient.value = item.name;
                    return groceryForSelect;
                });
                let temp = [...data, ...tempData]
                setOptions(temp);
            });
        })
    }

    const getClients = () => {
        ClientService.getClientsShort().then((response) => {
            let data = response.data.map(client => {
                let temp = { ...client }
                temp.value = client.name
                temp.label = client.name
                return temp
            })
            setClientsData(data)
        })
    };

    const mapTabs = () => {
        mapTabList()
        mapTabContent()
    }

    const loadDefaultData = () => {
        if ((planId && planId !== ":planId") && (clientId && clientId !== ":clientId")) {
            ClientService.getClient(clientId).then((response) => {
                let data = { ...response.data,
                    value: response.data.name,
                    label: response.data.name,
                }
                let tempClients = [data]
                setSelectedClients(tempClients);
                loadMenusForTab(data, 0);   // učitaj sve jelovnike klijenta
            });
        } else if (clientId && clientId !== ":clientId") {
            ClientService.getClient(clientId).then((response) => {
                let data = {
                    ...response.data,
                    value: response.data.name,
                    label: response.data.name,
                }
                let tempClients = [data]
                setSelectedClients(tempClients);
                loadMenusForTab(data, 0);   // učitaj sve jelovnike klijenta
            });
        }
    }

    const setPlanDataOnLoad = (response, index) => {
        let rows = response.data.times ? response.data.times.length : 0;
        let commentRows = response.data.comments ? response.data.comments.length : 0;

        let tempRows = newnoOfRows;
        tempRows[index] = rows;
        let tempComments = newnoOfCommentRows;
        tempComments[index] = commentRows;
        let tempPlanData = plansData;
        tempPlanData[index] = response.data;
        setPlansData([...tempPlanData]);
        setNewNoOfRows([...tempRows]);
        setNewNoCommentOfRows([...tempComments]);
    }

    const newsavePlan = (index) => {
        plansData[index].clientId = selectedClients[index].id
        PlanService.updatePlan(plansData[index]).then(response => {
            console.log(response)
            MySwal.fire({
                title: "Successfully saved plan",
                showCancelButton: true,
                showDenyButton: false,
                showConfirmButton: false,
                cancelButtonText: `Close`,
            })
        })
    }

    const newaddPlan = (index) => {
        plansData[index].clientId = selectedClients[index].id
        plansData[index].id = undefined
        // redni broj jelovnika = trenutno izabrani + 1 (ili postojeci ako vec ima)
        if (!plansData[index].menuNumber) {
            const active = (activeMenu[index] || 0);
            plansData[index].menuNumber = active + 1;
        }
        PlanService.addPlan(plansData[index]).then(response => {
            let tempPlanData = plansData;
            tempPlanData[index] = response.data;
            setPlansData([...tempPlanData]);
            // osvezi listu jelovnika ovog klijenta
            const tempMenus = [...menusByTab];
            const list = tempMenus[index] ? [...tempMenus[index]] : [];
            list[(activeMenu[index] || 0)] = response.data;
            tempMenus[index] = list;
            setMenusByTab(tempMenus);
            MySwal.fire({
                title: "Successfully created new plan",
                showCancelButton: true,
                showDenyButton: false,
                showConfirmButton: false,
                cancelButtonText: `Close`,
            })
        })
    }
    const newsendPlan = (index) => {
        plansData[index].clientId = selectedClients[index].id
        PlanService.sendPlan(plansData[index]).then(response => {
            console.log(response)
            MySwal.fire({
                title: "Successfully sent plan",
                showCancelButton: true,
                showDenyButton: false,
                showConfirmButton: false,
                cancelButtonText: `Close`,
            })
        })
    }

    // Koliko jelovnika paket dozvoljava. Bez paketa = 1 (kao dosad).
    const maxMenusForClient = (client) => {
        const p = client && client.packageType;
        if (p === 'NutriM60') return 2;
        if (p === 'NutriM Premium') return 3;
        return 1; // NutriM30 ili bez paketa
    };

    // Redni broj jelovnika (1-based) za plan; stari planovi bez broja = po redosledu
    const menuNumberOf = (plan, fallbackIndex) => {
        if (plan && plan.menuNumber) return plan.menuNumber;
        return fallbackIndex + 1;
    };

    // Ucitava SVE jelovnike klijenta u dati tab; bira prvi (ili prazan ako nema)
    const loadMenusForTab = (client, index) => {
        PlanService.getPlanByClientId(client.id).then((response) => {
            const list = (response && response.data) ? response.data : [];
            // sortiraj po menuNumber (stari bez broja idu po postojecem redu)
            const sorted = [...list].sort((a, b) => (a.menuNumber || 0) - (b.menuNumber || 0));

            const tempMenus = [...menusByTab];
            const tempActive = [...activeMenu];
            if (sorted.length > 0) {
                tempMenus[index] = sorted;
                tempActive[index] = 0;
                setMenusByTab(tempMenus);
                setActiveMenu(tempActive);
                showMenu(sorted, 0, index);
            } else {
                // nema nijednog jelovnika - prazan prvi
                const empty = { ...makeEmptyPlan(), clientId: client.id, menuNumber: 1 };
                tempMenus[index] = [empty];
                tempActive[index] = 0;
                setMenusByTab(tempMenus);
                setActiveMenu(tempActive);
                showMenu([empty], 0, index);
            }
        });
    };

    // Prikazuje izabrani jelovnik u sadrzaju taba
    const showMenu = (menus, menuIdx, tabIndex) => {
        const plan = clonePlan(menus[menuIdx]);
        const rows = plan && plan.times ? plan.times.length : 0;
        const commentRows = plan && plan.comments ? plan.comments.length : 0;
        const tempRows = [...newnoOfRows]; tempRows[tabIndex] = rows || 4;
        const tempComments = [...newnoOfCommentRows]; tempComments[tabIndex] = commentRows;
        const tempPlanData = [...plansData]; tempPlanData[tabIndex] = plan;
        setNewNoOfRows(tempRows);
        setNewNoCommentOfRows(tempComments);
        setPlansData(tempPlanData);
    };

    // Snima trenutni sadrzaj (plansData) nazad u listu jelovnika, da se izmene
    // ne izgube pri prebacivanju. Vraca azuriranu kopiju menusByTab.
    const stashCurrentMenu = (tabIndex) => {
        const tempMenus = [...menusByTab];
        const menus = tempMenus[tabIndex] ? [...tempMenus[tabIndex]] : [];
        const curIdx = activeMenu[tabIndex] || 0;
        if (menus.length > 0 && plansData[tabIndex]) {
            menus[curIdx] = clonePlan(plansData[tabIndex]);
            tempMenus[tabIndex] = menus;
        }
        return tempMenus;
    };

    // Prebacivanje na drugi jelovnik istog klijenta
    const switchMenu = (tabIndex, menuIdx) => {
        const stashed = stashCurrentMenu(tabIndex);
        const menus = stashed[tabIndex] || [];
        if (menuIdx < 0 || menuIdx >= menus.length) return;
        setMenusByTab(stashed);
        const tempActive = [...activeMenu]; tempActive[tabIndex] = menuIdx;
        setActiveMenu(tempActive);
        showMenu(menus, menuIdx, tabIndex);
    };

    // Dodaje nov (prazan) jelovnik ako paket dozvoljava
    const addMenu = (tabIndex) => {
        const client = selectedClients[tabIndex];
        const stashed = stashCurrentMenu(tabIndex);
        const menus = stashed[tabIndex] || [];
        const max = maxMenusForClient(client);
        if (menus.length >= max) {
            MySwal.fire({
                title: 'Paket ' + (client.packageType || '(nije izabran)') + ' dozvoljava ' + max + ' jelovnik(a).',
                showConfirmButton: false, showCancelButton: true, cancelButtonText: 'U redu',
            });
            return;
        }
        const empty = { ...makeEmptyPlan(), clientId: client.id, menuNumber: menus.length + 1 };
        const tempMenus = [...stashed];
        tempMenus[tabIndex] = [...menus, empty];
        setMenusByTab(tempMenus);
        switchMenuAfterAdd(tabIndex, tempMenus[tabIndex].length - 1, tempMenus);
    };

    const switchMenuAfterAdd = (tabIndex, menuIdx, tempMenus) => {
        const tempActive = [...activeMenu]; tempActive[tabIndex] = menuIdx;
        setActiveMenu(tempActive);
        showMenu(tempMenus[tabIndex], menuIdx, tabIndex);
    };

    // Brise ceo jelovnik: iz baze (ako je sacuvan) i iz liste. Preostali jelovnici
    // se prenumerisu (1,2,3...), pa se prebacuje na prethodni.
    const deleteMenu = (tabIndex, menuIdx) => {
        const menus = menusByTab[tabIndex] || [];
        const target = menus[menuIdx];
        const menuNo = menuNumberOf(target, menuIdx);

        MySwal.fire({
            title: 'Obrisati Jelovnik ' + menuNo + '?',
            text: 'Ovo trajno briše ceo jelovnik.',
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Obriši',
            cancelButtonText: 'Otkaži',
            confirmButtonColor: '#c0392b',
        }).then((result) => {
            if (!result.isConfirmed) return;

            const removeFromState = () => {
                const stashed = stashCurrentMenu(tabIndex);
                const list = [...(stashed[tabIndex] || [])];
                list.splice(menuIdx, 1);
                // prenumerisi preostale jelovnike (1,2,3...)
                list.forEach((m, i) => { if (m) m.menuNumber = i + 1; });

                const tempMenus = [...stashed];
                if (list.length === 0) {
                    // ako je obrisan jedini, napravi prazan prvi
                    list.push({ ...makeEmptyPlan(), clientId: selectedClients[tabIndex].id, menuNumber: 1 });
                }
                tempMenus[tabIndex] = list;
                setMenusByTab(tempMenus);

                const newActive = Math.max(0, menuIdx - 1);
                const tempActive = [...activeMenu]; tempActive[tabIndex] = newActive;
                setActiveMenu(tempActive);
                showMenu(list, newActive, tabIndex);
            };

            if (target && target.id) {
                PlanService.deletePlan(target.id).then(removeFromState).catch(removeFromState);
            } else {
                removeFromState(); // nesacuvan jelovnik - samo iz liste
            }
        });
    };

    const newselectClient = (client, index) => {
        let temp = [...selectedClients]
        temp[index] = client
        setSelectedClients(temp)
        loadMenusForTab(client, index);
    }

    const selectPlan = (id, index) => {
        PlanService.getLastByClientId(id).then(response => {
            if (response && response.data) {
                setPlanDataOnLoad(response, index)
            } 
        })
    }

    const addTab = () => {
        let temp = [...selectedClients]
        temp.push({})
        setSelectedClients(temp)

        let tempRows = newnoOfRows
        tempRows.push(4)

        let tempComments = newnoOfCommentRows
        tempComments.push(0)

        let tempPlanData = plansData
        tempPlanData.push(makeEmptyPlan())

        setNewNoOfRows([...tempRows])
        setNewNoCommentOfRows([...tempComments])
        setPlansData([...tempPlanData])
    }


    const removeTab = (index) => {
        let temp = [...selectedClients]
        temp.splice(index, 1)
        setSelectedClients(temp)

        let tempPlanData = plansData
        tempPlanData.splice(index, 1)
        setPlansData([...tempPlanData])
    }

    const setNewPlanData = (planData, index) => {
        let tempPlanData = plansData
        tempPlanData[index] = { ...planData }
        setPlansData([...tempPlanData])
    }

    const setNewNOR = (rows, index) => {
        let tempRows = newnoOfRows
        tempRows[index] = rows
        setNewNoOfRows([...tempRows])
    }

    const setNewCNOR = (rows, index) => {
        let tempRows = newnoOfCommentRows
        tempRows[index] = rows
        setNewNoCommentOfRows([...tempRows])
    }



    const mapTabList = () => {
        let tempClients = [...selectedClients]
        let mappedListItems = tempClients.map((client, index) => {
            return (<Tab key={index}><TabItem key={index} openTab={openTab} removeTab={removeTab} setOpenTab={setOpenTab} clients={clientsData} selectedClient={client} setSelectedClient={newselectClient} index={index}></TabItem></Tab>);
        })
        let mappedTemp = (
            <TabList>
                {mappedListItems}
                <button type="button" className="rounded-full  w-6 h-6 p-1  bg-blueSecondary ml-3 text-white  transform hover:rotate-90 transition" onClick={() => { addTab() }}><PlusIcon /></button>
            </TabList>
        )
        setMappedTabList(mappedTemp)
    }

    const mapTabContent = () => {
        let tempPlans = [...plansData]
        let tempContent = tempPlans.map((plan, index) => {
            return (
                <TabPanel key={index}>
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                        <div className="">
                            {selectedClients[index] && selectedClients[index].id &&
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px', borderBottom: '1px solid #eee', flexWrap: 'wrap' }}>
                                    <span style={{ fontSize: '12px', color: '#888', marginRight: '4px' }}>Jelovnici:</span>
                                    {(menusByTab[index] || []).map((m, mi) => (
                                        <span key={mi} style={{ display: 'inline-flex', alignItems: 'center' }}>
                                            <button type="button" onClick={() => switchMenu(index, mi)}
                                                style={{
                                                    padding: '5px 14px', borderRadius: '6px', fontSize: '13px', cursor: 'pointer',
                                                    border: (activeMenu[index] || 0) === mi ? 'none' : '1px solid #ddd',
                                                    background: (activeMenu[index] || 0) === mi ? '#6F343F' : '#fff',
                                                    color: (activeMenu[index] || 0) === mi ? '#fff' : '#555',
                                                    fontWeight: (activeMenu[index] || 0) === mi ? 600 : 400,
                                                }}>
                                                Jelovnik {menuNumberOf(m, mi)}
                                            </button>
                                            {(activeMenu[index] || 0) === mi &&
                                                <button type="button" onClick={() => deleteMenu(index, mi)}
                                                    title="Obriši ovaj jelovnik"
                                                    style={{ marginLeft: '2px', marginRight: '4px', width: '20px', height: '20px', borderRadius: '50%', border: 'none', background: '#e7c6c6', color: '#8a2020', fontSize: '13px', lineHeight: '1', cursor: 'pointer' }}>
                                                    ×
                                                </button>}
                                        </span>
                                    ))}
                                    {(menusByTab[index] || []).length < maxMenusForClient(selectedClients[index]) &&
                                        <button type="button" onClick={() => addMenu(index)}
                                            style={{ padding: '5px 12px', borderRadius: '6px', fontSize: '13px', cursor: 'pointer', border: '1px dashed #bbb', background: '#fafafa', color: '#6F343F' }}>
                                            + Novi jelovnik
                                        </button>}
                                    <span style={{ marginLeft: 'auto', fontSize: '11px', color: '#aaa' }}>
                                        Paket: {selectedClients[index].packageType || 'nije izabran'}
                                    </span>
                                </div>}
                            <div className="tab-content tab-space">
                                <TabContent key={index}
                                    planIndex={index}
                                    openTab={openTab}
                                    planData={plan}
                                    options={options}
                                    setPlanData={setNewPlanData}
                                    sendPlan={newsendPlan}
                                    addPlan={newaddPlan}
                                    savePlan={newsavePlan}
                                    noOfRows={newnoOfRows[index]}
                                    setNoOfRows={setNewNOR}
                                    noOfCommentRows={newnoOfCommentRows[index]}
                                    setNoCommentOfRows={setNewCNOR}
                                    selectExistingClientsPlan={selectPlan}
                                    selectedClient={selectedClients[index]}
                                    usedRecipes={recipesFromPreviousMenus(index)}
                                    clients={clientsData}> </TabContent>
                            </div>
                        </div>
                    </div>
                </TabPanel>
            );
        })
        setMappedTabContent(tempContent)
    }


    return (
        <>
            <div className="flex flex-wrap">
                <div className="w-full">
                    <Tabs>
                        {mappedTabList}
                        {mappedTabContent}
                    </Tabs>
                </div>
            </div>
        </>
    );
};


export default function TabsRender() {
    return (
        <>
            <Plans />
        </>
    );
}